import styled from 'styled-components';

import { Radio } from 'ui/radio';
import { colors, fonts, fontWeights, spacing } from 'ui/theme';

import { LOOKUP_TYPE_TO_HUMAN_READABLE_NAME } from '../../constant';
import { useFormContext } from '../../contexts/FormContext';
import { LookupType } from '../../types';

const Wrapper = styled.li`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.threeEights};
`;

const Label = styled.label`
  margin: 0;
  font-weight: ${fontWeights.regular};
  color: ${colors.textPrimary};
  font-family: ${fonts.sansSerif};
`;

export const LookupTypeRadio = ({ lookupType }: { lookupType: LookupType }) => {
  const { lookupType: selectedLookupType, setLookupType, isSubmitting } = useFormContext();
  const id = `lookup-type-radio--${lookupType}`;
  return (
    <Wrapper>
      <Radio
        id={id}
        name="lookup-type-radio"
        data-test="lookup-type-radio"
        isChecked={lookupType === selectedLookupType}
        isDisabled={isSubmitting}
        onClick={() => setLookupType(lookupType)}
        value={lookupType}
      />
      <Label htmlFor={id}>{LOOKUP_TYPE_TO_HUMAN_READABLE_NAME[lookupType]}</Label>
    </Wrapper>
  );
};
